import type { InputProps } from '../internal/input';
import Input from '../internal/input';

export type TextInputProps = InputProps;

export default Input;
